import { useEffect, useState } from 'react';
import { fetchYoutubeTitle, titleMatchesSong } from '../../services/videoTitleCheck';

/**
 * The real title of a YouTube link, and whether it names the song
 * (services/videoTitleCheck.js). One lookup per distinct link; a stale answer
 * for a link the teacher has already changed is dropped.
 *
 * status: 'idle' (no link) | 'loading' | 'ready' | 'unknown' (could not read it)
 */
const useYoutubeLinkTitle = (url, songName) => {
	const [state, setState] = useState({ url: null, status: 'idle', title: null, channel: null });
	const link = String(url || '').trim();

	useEffect(() => {
		if (!link) {
			setState({ url: null, status: 'idle', title: null, channel: null });
			return undefined;
		}
		let live = true;
		setState({ url: link, status: 'loading', title: null, channel: null });
		fetchYoutubeTitle(link).then((info) => {
			if (!live) return;
			setState(info
				? { url: link, status: 'ready', title: info.title, channel: info.channel }
				: { url: link, status: 'unknown', title: null, channel: null });
		});
		return () => {
			live = false;
		};
	}, [link]);

	const matches = state.status === 'ready' ? titleMatchesSong(state.title, songName) : null;
	return { ...state, matches, mismatch: matches === false };
};

export default useYoutubeLinkTitle;
